import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {AddPresetCountriesComponent} from "@features/preset-countries/components/add-preset-countries/add-preset-countries.component";
// @dynamic
export class PresetCountriesDynamicComponentHelper {
  static components: any;

  static create (): void {
  }

  public static init () {
    if (PresetCountriesDynamicComponentHelper.components) {
      return;
    }
    const components = {};
    components['AddPresetCountriesComponent'] = AddPresetCountriesComponent; 
    PresetCountriesDynamicComponentHelper.components = components;
    RootDynamicComponentHelper.merge(components);
  }

  public static getComponentArray (): any[] {
    PresetCountriesDynamicComponentHelper.init();
    const componentArray = [];
    Object.keys(PresetCountriesDynamicComponentHelper.components).forEach(key => {
      componentArray.push(PresetCountriesDynamicComponentHelper.components[key]);
    });
    return componentArray;
  }

  public static register(key: string, component: any) {
    PresetCountriesDynamicComponentHelper.components[key] = component;
    RootDynamicComponentHelper.register(key, component);
  }
}
